var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertPhysical01 = function SvgAlertPhysical01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_physical-01_svg2__a",
    x1: 29.91,
    x2: 196.36,
    y1: 215.48,
    y2: 60.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_physical-01_svg2__a",
    id: "alert_physical-01_svg2__b",
    x1: -38.82,
    x2: 127.63,
    y1: 141.88,
    y2: -13.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_physical-01_svg2__a",
    id: "alert_physical-01_svg2__c",
    x1: 37.79,
    x2: 204.24,
    y1: 223.92,
    y2: 68.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_physical-01_svg2__a",
    id: "alert_physical-01_svg2__d",
    x1: -36.2,
    x2: 130.25,
    y1: 144.69,
    y2: -10.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_physical-01_svg2__a",
    id: "alert_physical-01_svg2__e",
    x1: 13.03,
    x2: 179.47,
    y1: 197.4,
    y2: 41.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_physical-01_svg2__a",
    id: "alert_physical-01_svg2__f",
    x1: -15.01,
    x2: 151.43,
    y1: 167.37,
    y2: 11.94
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_physical-01_svg2__a",
    id: "alert_physical-01_svg2__g",
    x1: -52.01,
    x2: 114.44,
    y1: 127.76,
    y2: -27.68
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_physical-01_svg2__a",
    id: "alert_physical-01_svg2__h",
    x1: -51.05,
    x2: 115.4,
    y1: 128.78,
    y2: -26.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_physical-01_svg2__a",
    id: "alert_physical-01_svg2__i",
    x1: -3.16,
    x2: 163.28,
    y1: 180.06,
    y2: 24.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_physical-01_svg2__a",
    id: "alert_physical-01_svg2__j",
    x1: 16.65,
    x2: 183.1,
    y1: 201.28,
    y2: 45.84
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.81 168.04v-4.11c0-11.02-8.88-19.99-19.85-20.17V91.67c0-28.65-23.31-51.95-51.95-51.95S48.06 63.03 48.06 91.67v52.09c-10.98.18-19.85 9.15-19.85 20.17v4.11c-9.07 1.98-15.88 10.06-15.88 19.72v7.94a4.31 4.31 0 0 0 4.31 4.31h166.77a4.31 4.31 0 0 0 4.31-4.31v-7.94c0-9.65-6.81-17.74-15.88-19.72ZM56.66 91.66c0-23.9 19.44-43.34 43.34-43.34s43.34 19.44 43.34 43.34v52.08H56.66zM36.8 163.93c0-6.38 5.19-11.58 11.58-11.58h103.24c6.38 0 11.58 5.19 11.58 11.58v3.64H36.8zm142.28 27.46H20.92v-3.64c0-6.38 5.19-11.58 11.58-11.58h135c6.38 0 11.58 5.19 11.58 11.58z",
    style: {
      fill: "url(#alert_physical-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 24.5a4.31 4.31 0 0 0 4.31-4.31V4.31a4.31 4.31 0 0 0-8.62 0v15.88A4.31 4.31 0 0 0 100 24.5",
    style: {
      fill: "url(#alert_physical-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36 87.36h-15.88a4.31 4.31 0 0 0 0 8.62h15.88a4.31 4.31 0 0 0 0-8.62",
    style: {
      fill: "url(#alert_physical-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.53 95.97a4.31 4.31 0 0 0 0-8.62H12.65a4.31 4.31 0 0 0 0 8.62z",
    style: {
      fill: "url(#alert_physical-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.9 60.23c.73 0 1.47-.19 2.15-.58l13.76-7.94a4.304 4.304 0 0 0 1.58-5.88 4.304 4.304 0 0 0-5.88-1.58l-13.76 7.94a4.304 4.304 0 0 0-1.58 5.88c.8 1.38 2.25 2.15 3.73 2.15Z",
    style: {
      fill: "url(#alert_physical-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.58 33.49c.68.39 1.42.58 2.15.58 1.49 0 2.94-.77 3.73-2.15l7.94-13.75c1.19-2.06.48-4.69-1.58-5.88s-4.69-.48-5.88 1.58L132 27.62a4.304 4.304 0 0 0 1.58 5.88Z",
    style: {
      fill: "url(#alert_physical-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.53 31.92a4.3 4.3 0 0 0 5.88 1.57 4.304 4.304 0 0 0 1.58-5.88l-7.94-13.75a4.31 4.31 0 0 0-5.88-1.58 4.304 4.304 0 0 0-1.58 5.88l7.94 13.75Z",
    style: {
      fill: "url(#alert_physical-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.19 51.71 13.76 7.94c.68.39 1.42.58 2.15.58 1.49 0 2.94-.77 3.73-2.15 1.19-2.06.48-4.69-1.58-5.88l-13.76-7.94a4.304 4.304 0 0 0-5.88 1.58 4.304 4.304 0 0 0 1.58 5.88Z",
    style: {
      fill: "url(#alert_physical-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 103.91a4.31 4.31 0 0 0 4.31-4.31V67.83a4.31 4.31 0 0 0-8.62 0V99.6a4.31 4.31 0 0 0 4.31 4.31",
    style: {
      fill: "url(#alert_physical-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.02 119.12c-2.38 0-4.3 1.93-4.3 4.31a4.31 4.31 0 1 0 4.31-4.31Z",
    style: {
      fill: "url(#alert_physical-01_svg2__j)"
    }
  }));
};
export default SvgAlertPhysical01;